import Head from 'next/head'
import shopInfos from 'template/infos'
const { name, url } = shopInfos

const Seo: React.FC = () => <Head>

  <title>{`Kontakt zu ${name}`}</title>

  <meta name='description' content={
    `Fragen oder Wünsche, schreiben Sie uns einfach, 
    gerne helfen wir weiter und beraten sie.`
  } />

  <link rel='canonical' href={`${url}kontakt`} />

</Head>

export default Seo
